import React from 'react'

function Logo() {
  return <div className="ama-logo">AMA</div>
}

export default Logo
